import { MdChevronRight } from "react-icons/md";
import "./HomePageCss/WelcomeSection.css";
import AnimatedText from "../../AnimatedText";
import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import useIsMobile from "../../Hooks/IsmobileHook";

import bookAnApp from "../../Assets/buttonIcons0/Book an Appointment (1).png";
import homeCollection from "../../Assets/buttonIcons0/Home Collection (1).png";
import viewReport from "../../Assets/buttonIcons0/View Reports.png";
import viewTest from "../../Assets/buttonIcons0/Book a Test (2).png";
import { needHelpCallBack } from "../../api/api";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomLoader from "../../common/loader/CustomLoader";
import RBlogo from "../../Assets/RBlogoPng.png";

// Yup validation

const validationSchema = Yup.object({
  first_name: Yup.string().trim().required("Name is required"),
  phone_number: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
    .required("Phone number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  comment: Yup.string()
    .trim()
    .required("Please enter your query")
    .test("word-count", "Query must not exceed 150 words", (value) =>
      value ? value.trim().split(/\s+/).length <= 15 : true
    ),
});

// complete

const WelcomeSection = () => {
  const isMobile = useIsMobile();
  const navigation = useNavigate();

  const handleHomeCollection = () => navigation("/home-collection");
  const handleViewReport = () => navigation("/view-reports");
  const handleBookAppointment = () => navigation("/doctors-grid");
  const handleTestPage = () => navigation("/test-packages");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [payload, setPayload] = useState({
    phone_number: "",
    first_name: "",
    email: "",
    comment: "",
  });

  // save data from input using onchange
  const valupd = (e) => {
    setPayload({ ...payload, [e.target.name]: e.target.value });
  };

  //

  // call needHelpCallBack api
  const fetchNeedHelpCallBack = async (payload) => {
    try {
      setLoading(true);
      setMessage(""); // reset message before call

      const res = await needHelpCallBack(payload);

      if (res?.data?.status?.toLowerCase() === "success") {
        setMessage(res?.data?.message || "Request submitted successfully!");
        // setShowPopup(true); // ✅ show popup only on success
        setPayload({
          first_name: "",
          phone_number: "",
          email: "",
          comment: "",
        }); // reset form
      } else {
        //  do nothing, no message, no popup
        console.log("API returned failure:", res?.data);
        setMessage("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Error submitting help request:", err);
      //  do nothing, no message, no popup
      setMessage("Server error. Please try again later.");
      setShowPopup(true);
    } finally {
      setLoading(false);
    //   setShowPopup(true);
    }
  };

  // comlete needHelpCallBack calling
  console.log("mesage-->", message);

  return (
    <div className="WelcomeContainer">
      <div className="leftWelcomeSection">
        {/* <AnimatedText tag="h2" type="words" y={30}>
                    Welcome to RB Diagnostics
                </AnimatedText> */}
        <h2>Welcome to RB Diagnostic</h2>

        <p className="RBIntro onlyForDesktop">
          At RB Diagnostic, we welcome you to a world of precise diagnostics and
          patient-first care, where advanced technology and trusted expertise
          come together for your well-being.
        </p>

        <p className="RBIntro onlyForMobile">
          RB Diagnostic: Precision care through advanced technology and trusted
          expertise.
        </p>

        <div className="leftBottomWelcomeSection">
          {isMobile ? (
            <div className="mobileButtonsRow">
              <div
                className="mobileCardBtn"
                style={{ backgroundColor: "#cfdfec" }}
                onClick={handleBookAppointment}
              >
                <img src={bookAnApp} alt="Book a Test" />
                <span>Book an Appointment</span>
              </div>
              <div
                className="mobileCardBtn"
                style={{ backgroundColor: "#d7ece5" }}
                onClick={handleHomeCollection}
              >
                <img src={homeCollection} alt="Consult a Doctor" />
                <span>Home Collection</span>
              </div>
              <div
                className="mobileCardBtn"
                style={{ backgroundColor: "#f1ded8" }}
                onClick={handleViewReport}
              >
                <img src={viewReport} alt="Download Report" />
                <span>View Report</span>
              </div>
              <div
                className="mobileCardBtn"
                style={{ backgroundColor: "#d6d3f2" }}
                onClick={handleTestPage}
              >
                <img src={viewTest} alt="Nearest Centers" />
                <span>
                  Book <br />
                  Tests
                </span>
              </div>
            </div>
          ) : (
            <>
              <div className="cardUpSection">
                <div
                  className="cardsSection"
                  style={{ backgroundColor: "#cfdfec" }}
                  onClick={handleBookAppointment}
                >
                  <div className="cardUpperSection">
                    <span className="imageIcon">
                      <img src={bookAnApp} alt="Book an Appointment" />
                    </span>
                    <motion.div
                      animate={{ x: [0, 6, 0] }}
                      transition={{
                        repeat: Infinity,
                        duration: 1.2,
                        ease: "easeInOut",
                      }}
                    >
                      <MdChevronRight
                        style={{
                          color: "black",
                          fontWeight: "700",
                          fontSize: "2rem",
                        }}
                      />
                    </motion.div>
                  </div>
                  <h4>Book an Appointment</h4>
                  <p>
                    Schedule your doctor appointment effortlessly with our easy
                    online booking system
                  </p>
                </div>

                <div
                  className="cardsSection"
                  style={{ backgroundColor: "#d7ece5" }}
                  onClick={handleHomeCollection}
                >
                  <div className="cardUpperSection">
                    <span className="imageIcon">
                      <img src={homeCollection} alt="Consult a Doctor" />
                    </span>
                    <motion.div
                      animate={{ x: [0, 6, 0] }}
                      transition={{
                        repeat: Infinity,
                        duration: 1.2,
                        ease: "easeInOut",
                      }}
                    >
                      <MdChevronRight
                        style={{
                          color: "black",
                          fontWeight: "700",
                          fontSize: "2rem",
                        }}
                      />
                    </motion.div>
                  </div>
                  <h4>Home Collection</h4>
                  <p>
                    Our home collection services ensure accurate sample
                    collection and timely reporting.
                  </p>
                </div>
              </div>

              <div className="cardUpSection">
                <div
                  className="cardsSection"
                  style={{ backgroundColor: "#f1ded8" }}
                  onClick={handleViewReport}
                >
                  <div className="cardUpperSection">
                    <span className="imageIcon">
                      <img src={viewReport} alt="Download Report" />
                    </span>
                    <motion.div
                      animate={{ x: [0, 6, 0] }}
                      transition={{
                        repeat: Infinity,
                        duration: 1.2,
                        ease: "easeInOut",
                      }}
                    >
                      <MdChevronRight
                        style={{
                          color: "black",
                          fontWeight: "700",
                          fontSize: "2rem",
                        }}
                      />
                    </motion.div>
                  </div>
                  <h4>View Reports</h4>
                  <p>
                    Access your medical reports securely anytime from our online
                    portal
                  </p>
                </div>

                <div
                  className="cardsSection"
                  style={{ backgroundColor: "#d6d3f2" }}
                  onClick={handleTestPage}
                >
                  <div className="cardUpperSection">
                    <span className="imageIcon">
                      <img src={viewTest} alt="Nearest Centers" />
                    </span>
                    <motion.div
                      animate={{ x: [0, 6, 0] }}
                      transition={{
                        repeat: Infinity,
                        duration: 1.2,
                        ease: "easeInOut",
                      }}
                    >
                      <MdChevronRight
                        style={{
                          color: "black",
                          fontWeight: "700",
                          fontSize: "2rem",
                        }}
                      />
                    </motion.div>
                  </div>
                  <h4>Book Tests</h4>
                  <p>
                    Explore our comprehensive list of diagnostic tests and their
                    details.
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="rightWelcomeSection">
        {/* internal css */}

        {loading && (
          <div className="loader-overlay">
            <CustomLoader />
          </div>
        )}
        <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
        }

        .modal-box {
          background: #fff;
          padding: 30px;
          border-radius: 15px;
          text-align: center;
          max-width: 400px;
          width: 90%;
          box-shadow: 0 4px 15px rgba(0,0,0,0.3);
        }

        .modal-box img {
          height: 50px;
          margin-bottom: 15px;
        }

        .modal-box p {
          font-size: 16px;
          margin-bottom: 20px;
          color: #333;
        }

        .close-btn {
          padding: 10px 25px;
          border: none;
          border-radius: 20px;
          background: #e74c3c;
          color: #fff;
          font-weight: bold;
          cursor: pointer;
          transition: 0.3s;
        }

        .close-btn:hover {
          background: #c0392b;
        }

        .error {
  color: red;
  margin-top: 0px;
    margin-bottom: 10px; 
  font-size:x-small;
}
  .alertText{        
    font-size:12px;
    color: red; 
  }

  .required {
  color: red;
  font-size: 15px;
  margin-left: 2px;
}



        
      `}</style>

        <Formik
          initialValues={{
            first_name: "",
            phone_number: "",
            email: "",
            comment: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            fetchNeedHelpCallBack(values);
            resetForm();
          }}
        >
          {({ isSubmitting, errors, values, touched }) => {
            // check if any required field is empty or invalid
            const isFormIncomplete =
              !values.first_name ||
              !values.phone_number ||
              !values.email ||
              !values.comment ||
              Object.keys(errors).length > 0;

            // check if user has touched at least one field
            const hasTouched = Object.keys(touched).length > 0;

            return (
              <Form>
                {/* <label>
                                    Name <span className="required">*</span>
                                </label> */}
                <Field name="first_name">
                  {({ field, form }) => (
                    <input
                      autoComplete="off"
                      {...field}
                      type="text"
                      placeholder="Name*"
                      onChange={(e) => {
                        const value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          ""
                        );
                        form.setFieldValue("first_name", value);
                      }}
                    />
                  )}
                </Field>

                <ErrorMessage
                  name="first_name"
                  component="p"
                  className="error"
                />

                {/* <label>
                                    Phone number <span className="required">*</span>
                                </label> */}
                <Field name="phone_number">
                  {({ field, form }) => (
                    <input
                      {...field}
                      autoComplete="off"
                      type="tel"
                      placeholder="Phone number*"
                      maxLength={10}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        form.setFieldValue("phone_number", value);
                      }}
                    />
                  )}
                </Field>

                <ErrorMessage
                  name="phone_number"
                  component="p"
                  className="error"
                />

                {/* <label>
                                        Email <span className="required">*</span>
                                    </label> */}
                <Field
                  name="email"
                  type="email"
                  placeholder="Email address*"
                  autoComplete="off"
                />
                <ErrorMessage name="email" component="p" className="error" />

                {/* <label>
                                    Query <span className="required">*</span>
                                </label> */}
                <Field name="comment">
                  {({ field, form }) => {
                    const words = field.value
                      ? field.value.trim().split(/\s+/)
                      : [];
                    const wordCount =
                      field.value.trim() === "" ? 0 : words.length;

                    return (
                      <>
                        <textarea
                          {...field}
                          rows="4"
                          placeholder="Query*"
                          onChange={(e) => {
                            // allow only letters and spaces
                            let value = e.target.value.replace(
                              /[^a-zA-Z\s]/g,
                              ""
                            );

                            // word limit
                            let wordList = value.trim().split(/\s+/);
                            if (wordList.length > 150) {
                              wordList = wordList.slice(0, 150);
                              value = wordList.join(" ");
                            }

                            form.setFieldValue("comment", value);
                          }}
                        />
                        <p style={{ fontSize: "12px" }}>
                          {wordCount}/150 words
                        </p>
                      </>
                    );
                  }}
                </Field>

                <ErrorMessage name="comment" component="p" className="error" />

                {/* ✅ Alert - only shows if touched & form incomplete */}
                {hasTouched && isFormIncomplete && (
                  <span className="alertText" style={{ color: "red" }}>
                    Please fill all the mandatory fields
                  </span>
                )}

                <button
                  style={{ cursor: "pointer" }}
                  type="submit"
                  className="rbdButton"
                  disabled={isSubmitting}
                >
                  <span className="btn-text">
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </span>
                </button>
              </Form>
            );
          }}
        </Formik>

        {/* Popup Modal — only when success */}
        {showPopup && (
          <div className="modal-overlay" onClick={() => setShowPopup(false)}>
            <div className="modal-box" onClick={(e) => e.stopPropagation()}>
              <img src={RBlogo} alt="RB Diagnostics" />
              <p>{message}</p>
              <button className="close-btn" onClick={() => setShowPopup(false)}>
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeSection;
